


/*
 * Date: 2025
 * Description: Dedicated body for prompt , yes or no
 * Author: Philippe Leroux @ Skitsc
 */

//Modules
import { forwardRef , useState } from "react"

import { Box, Typography, Grid, Button } from "@mui/material"

//Components
import CloseModal from "./close.modal"

//Styles
import { getBigModalStyle, modal_style } from "../../styles/modal.styles"

//Interfaces && types 
import { i_prompt_modal_props } from "../../interfaces/utility.interface"
import { t_transition_event } from "../../types/types"

const PromptBody = forwardRef((props : i_prompt_modal_props , ref) => {
    const [ modalStyle ] = useState(getBigModalStyle(props.mode))
    const returnTitle = ( value : t_transition_event) => {
        if(value === 'delete' || value === 'delete payment') return 'Are you sure you want to delete :'
        if(value === 'disable') return 'Are you sure you want to disable :'
        if(value === 'enable') return 'Are you sure you want to enable :'
        if(value === 'update') return 'Are you sure you want to edit :'
    }
    return(
        <Box component={'div'} style={modalStyle} sx={modal_style}>
            <CloseModal {...props}></CloseModal>
            <Grid container>
                    <Grid size={12}>
                        <Typography sx={{ textAlign : "center" , marginBottom : '1vh' , marginTop : '1vh'}}variant={"h5"}>{returnTitle(props.type)}</Typography>
                    </Grid>
                <Grid size={12}>
                    <Typography sx={{ textAlign : "center" , marginBottom : '3vh' , marginTop : '0vh'}}variant={"h5"}>{props.title}</Typography>
                </Grid>
                <Grid size={6} sx={{ display : 'flex' , justifyContent : 'center'}}>
                        <Button onClick={() => props.callback()} loading={props.loading} variant="contained" sx={[  { width : '40%'} ]}>Yes</Button>
                </Grid>
                <Grid size={6} sx={{ display : 'flex' , justifyContent : 'center'}}>
                    <Button disabled={props.loading} onClick={() => props.handleClose(true)} variant="contained" sx={ { width : '40%'}}>No</Button>
                </Grid>
            </Grid>
        </Box>
    )
})
export default PromptBody